// Must precede every other import: it disables Zod's `new Function`
// codegen probe, which our CSP blocks, and Zod reads that flag when the
// first object schema is constructed at module scope.
import './zod-jitless';

import './sentry';
import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';

import { App } from './App';
import i18n from './i18n';

import './App.css';
import './language-overrides.css';

createRoot(document.getElementById('clinic-locator') as HTMLElement).render(
  <Sentry.ErrorBoundary fallback={<p>An error occurred. Our team has been notified.</p>}>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </Sentry.ErrorBoundary>
);
